import * as React from 'react';
import { CardContent, Grid, TextField, MenuItem, Container, Typography, Card, Box, Tooltip } from '@mui/material';
import { DataGrid, esES, GridActionsCellItem  } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import { useEffect } from 'react';

const columns = [
    {
        field: 'nombre',
        headerName: 'Nombre',
        minWidth: 150,
        flex: 1,
        headerClassName: 'tableHeaders',
        renderHeader: () => (
            <span className="headerTable">Nombre</span>
          ),
    },
    {
      field: 'nombreEmpresa',
      headerName: 'Nombre empresa',
      minWidth: 150,
      flex: 1,
      headerClassName: 'tableHeaders',
      renderHeader: () => (
        <span className="headerTable">Nombre empresa</span>
      ),
    },
    {
      field: 'correo',
      headerName: 'Correo',
      minWidth: 150,
      flex: 1,
      headerClassName: 'tableHeaders',
      renderHeader: () => (
        <span className="headerTable">Correo</span>
      ),
    },
    {
      field: 'telefono',
      headerName: 'Teléfono',
      sortable: false,
      minWidth: 200,
      flex: 0.5,
      headerClassName: 'tableHeaders',
      renderHeader: () => (
        <span className="headerTable">Teléfono</span>
      ),
    },
    {
        field: 'estatus',
        headerName: 'Estatus',
        sortable: false,
        renderCell: () => <RenderEstatus/>,
        minWidth: 200,
        flex: 0.5,
        headerClassName: 'tableHeaders',
        renderHeader: () => (
            <span className="headerTable">Estatus</span>
          ),
    },
    {
        field: 'actions',
        type: 'actions',
        headerName: 'Acciones',
        headerClassName: 'tableHeaders',
        getActions: (params) => [
            <Tooltip title="Editar" placement="top">
                <GridActionsCellItem
                    icon={<EditIcon />}
                    label="Editar"
                    color='primary.main'
                />
            </Tooltip>,
            <Tooltip title="Eliminar" placement="top">
                <GridActionsCellItem
                icon={<DeleteIcon />}
                label="Eliminar"
                color='primary.main'
                />
            </Tooltip>,
        ],
    },
  ];
  
  const rows = [
    { id: 1, nombre:'Nombre 1', nombreEmpresa: 'Empresa 1', correo: 'correo@correo.com', telefono: '4511486523' },
    { id: 2, nombre:'Nombre 2', nombreEmpresa: 'Empresa 2', correo: 'correo@correo.com', telefono: '4511486523' },
    { id: 3, nombre:'Nombre 3', nombreEmpresa: 'Empresa 3', correo: 'correo@correo.com', telefono: '4511486523' },
    { id: 4, nombre:'Nombre 4', nombreEmpresa: 'Empresa 4', correo: 'correo@correo.com', telefono: '4511486523' },
    { id: 5, nombre:'Nombre 5', nombreEmpresa: 'Empresa 5', correo: 'correo@correo.com', telefono: '4511486523' },
    { id: 6, nombre:'Nombre 6', nombreEmpresa: 'Empresa 6', correo: 'correo@correo.com', telefono: '4511486523' },
    { id: 7, nombre:'Nombre 7', nombreEmpresa: 'Empresa 7', correo: 'correo@correo.com', telefono: '4511486523' },
  ];

  const RenderEstatus = () => {
    const [estatus, setEstatus] = React.useState('');

    const handleChangeEstatus = (event) => {
        setEstatus(event.target.value);
    };

    return(
        <Box
            noValidate
            component="form"
            className='p-2'
            sx={{display: 'flex', width: '100%'}}
        >
                <TextField
                    size="small"
                    select
                    fullWidth
                    id="selectEstatus"
                    value={estatus}
                    label="Estatus"
                    onChange={handleChangeEstatus}
                >
                    <MenuItem value={1}>Activo</MenuItem>
                    <MenuItem value={2}>Inactivo</MenuItem>
                </TextField>
        </Box>
    );
  }

function UsuariosProveedoresPages(){

    useEffect(() => {
        document.title='Lilofy | Usuarios Proveedores';
    }, [])

    const [pageSize, setPageSize] = React.useState(5);
    return(
        <>
        <div className="main-container" >
            <div className='mb-2'>
                <Typography color='primary' variant='h4'>
                    <PersonIcon sx={{marginRight: 2}} fontSize="large"/>
                    Usuarios proveedores
                </Typography>
            </div>
            <Card className='card'>
                <CardContent>
                    <Grid container direction={'row'} justifyContent="end" alignItems={"center"}>
                        <Grid item>
                            <TextField
                                size="small"
                                margin="normal"
                                fullWidth
                                id="filter"
                                label="Buscar"
                                name="filter"
                                />
                        </Grid>
                    </Grid>
                    <Box sx={{ 
                        width: '100%', 
                        '& .tableHeaders': {
                            color: 'primary.main',
                            }, 
                        }}>
                        <DataGrid
                            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            autoHeight 
                            rows={rows}
                            columns={columns}
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            rowsPerPageOptions={[5, 10, 20]}
                            pagination
                        />
                    </Box>
                </CardContent>
            </Card>
        </div>
        </>
    );
}

export default UsuariosProveedoresPages;